import Slogan from 'components/organisms/Profile/Slogan';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as profileAC, getIsUpdatingSlogan, getSlogan } from 'store/profile';

const mapStateToProps = (state) => ({
	slogan: getSlogan(state),
	isUpdatingSlogan: getIsUpdatingSlogan(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ doSaveSlogan: profileAC.doSaveSlogan }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Slogan as any);
